import React, { useState } from 'react';
import { Button } from 'flowbite-react';
import { useContent } from '../context/ContentContext';

function DomainInput({ domain, setDomain, setError }) {
  const { siteCredential,
    setSiteCredential
  } = useContent();
  const [inputValue, setInputValue] = useState(domain);
  const [username, setUsername] = useState(siteCredential.username || '');
  const [password, setPassword] = useState(siteCredential.password || '');

  const validateDomain = (value) => {
    // Basic domain validation regex
    const domainRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/)?$/i;
    return domainRegex.test(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateDomain(inputValue.trim())) {
      setError(null);
      setDomain(inputValue.trim());
      // Save credentials (they can be empty → optional)
      setSiteCredential({ url: inputValue.trim(), username: username.trim(), password: password.trim() });
    } else {
      setError('Please enter a valid blog domain (e.g., https://example.com)');
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="mb-6 flex flex-col gap-4 sm:flex-row sm:flex-wrap items-center justify-center"
    >
      <input
        type="text"
        placeholder="Enter blog domain (e.g., https://example.com)"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        className="border border-gray-300 rounded px-4 py-2 w-full sm:w-96 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      <input
        type="text"
        placeholder="Username (optional)"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        className="border border-gray-300 rounded px-4 py-2 w-full sm:w-72 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      <input
        type="password"
        placeholder="Password (optional)"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="border border-gray-300 rounded px-4 py-2 w-full sm:w-72 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      <Button type="submit" size="sm">
        Go
      </Button>
    </form>
  );
}

export default DomainInput;
